
export function loaderMask(state = {}, action) {
  switch (action.type) {
    case "show":
      return {
        type: action.type,
        show: true,
        text: action.message
      };
    case "hide":
      return {
        type: action.type,
        show: false,
        text: action.message
      };
    default:
      return state;
  }
}
